export const IconCheckmarkDone20: {
  name: 'icon_checkmark_done_20-f79194bae1db'
} = {
  name: 'icon_checkmark_done_20-f79194bae1db'
}
